import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CollectionsIcon from "@mui/icons-material/Collections";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Refine } from "@refinedev/core";
import routerProvider from "@refinedev/react-router";
import { adminMuiTheme } from "./admin.mui-theme";
import adminDataProvider from "./api/adminDataProvider";
import { AdminLayout } from "./layout/AdminLayout";
export var AdminApp = function () { return (_jsxs(ThemeProvider, { theme: adminMuiTheme, children: [_jsx(CssBaseline, {}), _jsx(Refine, { routerProvider: routerProvider, dataProvider: adminDataProvider, resources: [
                {
                    name: "documents",
                    list: "/admin/documents",
                    show: "/admin/documents/:id",
                    meta: { label: "KYC Documents", icon: _jsx(AssignmentIcon, {}) },
                },
                {
                    name: "collections",
                    list: "/admin/collections",
                    create: "/admin/collections/create",
                    edit: "/admin/collections/:id/edit",
                    meta: { label: "Collections", icon: _jsx(CollectionsIcon, {}) },
                },
            ], options: { syncWithLocation: true, warnWhenUnsavedChanges: false }, children: _jsx(AdminLayout, {}) })] })); };
